import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import SimpleFooter from "./components/common/SimpleFooter";
import Carousel from "./components/common/Carousel";
import ProjectSlider from "./components/common/ProjectSlider";
import AboutUs from "./components/user/AboutUs";
import Projects from "./components/user/Projects";
import Properties from "./components/user/Properties";
import About from "./components/user/About";
import Contact from "./components/user/Contact";
import WhatWeDo from "./components/user/WhatWeDo";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminProperties from "./components/admin/AdminProperties";
import AdminProjects from "./components/admin/AdminProjects";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import "./styles/GlobalStyles.css";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Rutas públicas */}
          <Route
            path="/"
            element={
              <main className="container-fluid p-0">
                <Carousel />
                <ProjectSlider />
                <WhatWeDo />
                <AboutUs />
                <Footer />
              </main>
            }
          />
          <Route
            path="/projects"
            element={
              <>
                <Projects />
                <SimpleFooter />
              </>
            }
          />
          <Route
            path="/properties"
            element={
              <>
                <Properties />
                <SimpleFooter />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <About />
                <SimpleFooter />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Contact />
                <SimpleFooter />
              </>
            }
          />

          {/* Rutas protegidas */}
          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/properties"
            element={
              <ProtectedRoute>
                <AdminProperties />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute>
                <AdminProjects />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

function Layout({ children }) {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Navbar />}
      {children}
    </>
  );
}

export default App;
